// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file v1/message_report.proto (package v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date } from "../google/type/date_pb";
import { file_google_type_date } from "../google/type/date_pb";
import { file_google_api_annotations } from "../google/api/annotations_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/message_report.proto.
 */
export const file_v1_message_report: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_google_type_date, file_google_api_annotations]);

/**
 * @generated from message v1.GetMessageReportRequest
 */
export type GetMessageReportRequest = Message<"v1.GetMessageReportRequest"> & {
  /**
   * @generated from field: repeated int32 customer_ids = 1;
   */
  customerIds: number[];

  /**
   * @generated from field: google.type.Date calculation_date_from = 2;
   */
  calculationDateFrom?: Date;

  /**
   * @generated from field: google.type.Date calculation_date_to = 3;
   */
  calculationDateTo?: Date;

  /**
   * @generated from field: optional string region = 4;
   */
  region?: string;
};

/**
 * Describes the message v1.GetMessageReportRequest.
 * Use `create(GetMessageReportRequestSchema)` to create a new message.
 */
export const GetMessageReportRequestSchema: GenMessage<GetMessageReportRequest> = /*@__PURE__*/
  messageDesc(file_v1_message_report, 0);

/**
 * @generated from message v1.GetMessageReportResponse
 */
export type GetMessageReportResponse = Message<"v1.GetMessageReportResponse"> & {
  /**
   * @generated from field: repeated v1.MessageReportItem items = 1;
   */
  items: MessageReportItem[];

  /**
   * @generated from field: repeated v1.MessageReportGroupTotal group_totals = 2;
   */
  groupTotals: MessageReportGroupTotal[];
};

/**
 * Describes the message v1.GetMessageReportResponse.
 * Use `create(GetMessageReportResponseSchema)` to create a new message.
 */
export const GetMessageReportResponseSchema: GenMessage<GetMessageReportResponse> = /*@__PURE__*/
  messageDesc(file_v1_message_report, 1);

/**
 * @generated from message v1.MessageReportGroupTotal
 */
export type MessageReportGroupTotal = Message<"v1.MessageReportGroupTotal"> & {
  /**
   * @generated from field: string username = 1;
   */
  username: string;

  /**
   * @generated from field: int32 customer_id = 2;
   */
  customerId: number;

  /**
   * @generated from field: string region = 3;
   */
  region: string;

  /**
   * @generated from field: string customer_name = 12;
   */
  customerName: string;

  /**
   * Grand totals calculated per group (username, customer_id, region)
   *
   * @generated from field: double grand_total_bet_amount = 4;
   */
  grandTotalBetAmount: number;

  /**
   * @generated from field: double grand_total_bet_amount_with_share = 5;
   */
  grandTotalBetAmountWithShare: number;

  /**
   * @generated from field: double grand_total_win_amount = 6;
   */
  grandTotalWinAmount: number;

  /**
   * @generated from field: double grand_total_winning_money_with_payout = 7;
   */
  grandTotalWinningMoneyWithPayout: number;

  /**
   * @generated from field: double grand_total_net_profit = 8;
   */
  grandTotalNetProfit: number;

  /**
   * Calculated based on customer profit_type:
   * - "all": net_profit * customer_commission_all.commission_rate
   * - "digits": (net_profit for bet_type_id [1,4,5,6] * commission_two_digits) + (net_profit for bet_type_id [2,3,7] * commission_three_digits)
   * - "separate": sum of gross_profit from items (net_profit * commission_rate per bet_type)
   *
   * @generated from field: double grand_total_gross_profit = 9;
   */
  grandTotalGrossProfit: number;

  /**
   * Two-digit totals (bet_type_id: 1, 4, 6, 7)
   *
   * @generated from field: double two_digit_total_bet_amount = 13;
   */
  twoDigitTotalBetAmount: number;

  /**
   * @generated from field: double two_digit_total_bet_amount_with_share = 14;
   */
  twoDigitTotalBetAmountWithShare: number;

  /**
   * @generated from field: double two_digit_total_win_amount = 15;
   */
  twoDigitTotalWinAmount: number;

  /**
   * @generated from field: double two_digit_winning_money_with_payout = 16;
   */
  twoDigitWinningMoneyWithPayout: number;

  /**
   * @generated from field: double two_digit_net_profit = 17;
   */
  twoDigitNetProfit: number;

  /**
   * @generated from field: double two_digit_gross_profit = 18;
   */
  twoDigitGrossProfit: number;

  /**
   * Three-digit totals (bet_type_id: 2, 3, 5)
   *
   * @generated from field: double three_digit_total_bet_amount = 19;
   */
  threeDigitTotalBetAmount: number;

  /**
   * @generated from field: double three_digit_total_bet_amount_with_share = 20;
   */
  threeDigitTotalBetAmountWithShare: number;

  /**
   * @generated from field: double three_digit_total_win_amount = 21;
   */
  threeDigitTotalWinAmount: number;

  /**
   * @generated from field: double three_digit_winning_money_with_payout = 22;
   */
  threeDigitWinningMoneyWithPayout: number;

  /**
   * @generated from field: double three_digit_net_profit = 23;
   */
  threeDigitNetProfit: number;

  /**
   * @generated from field: double three_digit_gross_profit = 24;
   */
  threeDigitGrossProfit: number;
};

/**
 * Describes the message v1.MessageReportGroupTotal.
 * Use `create(MessageReportGroupTotalSchema)` to create a new message.
 */
export const MessageReportGroupTotalSchema: GenMessage<MessageReportGroupTotal> = /*@__PURE__*/
  messageDesc(file_v1_message_report, 2);

/**
 * @generated from message v1.MessageReportItem
 */
export type MessageReportItem = Message<"v1.MessageReportItem"> & {
  /**
   * @generated from field: string username = 1;
   */
  username: string;

  /**
   * @generated from field: int32 customer_id = 2;
   */
  customerId: number;

  /**
   * @generated from field: string region = 3;
   */
  region: string;

  /**
   * @generated from field: int32 bet_type_id = 4;
   */
  betTypeId: number;

  /**
   * @generated from field: string bet_type_label = 5;
   */
  betTypeLabel: string;

  /**
   * @generated from field: string customer_name = 12;
   */
  customerName: string;

  /**
   * Aggregated amounts
   *
   * @generated from field: double total_bet_amount = 6;
   */
  totalBetAmount: number;

  /**
   * total_bet_amount * share_rate
   *
   * @generated from field: double total_bet_amount_with_share = 7;
   */
  totalBetAmountWithShare: number;

  /**
   * sum of win_amount
   *
   * @generated from field: double total_win_amount = 8;
   */
  totalWinAmount: number;

  /**
   * win_amount * payout_rate
   *
   * @generated from field: double winning_money_with_payout = 9;
   */
  winningMoneyWithPayout: number;

  /**
   * Profit calculations
   *
   * winning_money_with_payout - total_bet_amount_with_share
   *
   * @generated from field: double net_profit = 10;
   */
  netProfit: number;

  /**
   * net_profit * commission_rate
   *
   * @generated from field: double gross_profit = 11;
   */
  grossProfit: number;
};

/**
 * Describes the message v1.MessageReportItem.
 * Use `create(MessageReportItemSchema)` to create a new message.
 */
export const MessageReportItemSchema: GenMessage<MessageReportItem> = /*@__PURE__*/
  messageDesc(file_v1_message_report, 3);

/**
 * @generated from service v1.MessageReportService
 */
export const MessageReportService: GenService<{
  /**
   * @generated from rpc v1.MessageReportService.GetMessageReport
   */
  getMessageReport: {
    methodKind: "unary";
    input: typeof GetMessageReportRequestSchema;
    output: typeof GetMessageReportResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_v1_message_report, 0);

